module.exports = __webpack_public_path__ + "img/cert-filler.e6ab6e9.webp";